import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";
// import middleware from "../../middleware";
const WeaCascader = Loadable({
  loader: () => import("./Cascader"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

WeaCascader.WeaCustomField = Loadable({
  loader: () => import("./component/CustomField"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

// const Com = middleware(WeaCascader, "WeaCascader");
export default WeaCascader;



// WEBPACK FOOTER //
// ./ecology9/wea-cascader/index.js